/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeviceLoginTokenDto } from '../../models/device-login-token-dto';

export interface DeviceControllerGenerateQrLoginToken$Params {
  deviceId: string;
}

export function deviceControllerGenerateQrLoginToken(http: HttpClient, rootUrl: string, params: DeviceControllerGenerateQrLoginToken$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceLoginTokenDto>> {
  const rb = new RequestBuilder(rootUrl, deviceControllerGenerateQrLoginToken.PATH, 'post');
  if (params) {
    rb.path('deviceId', params.deviceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeviceLoginTokenDto>;
    })
  );
}

deviceControllerGenerateQrLoginToken.PATH = '/api/device/{deviceId}/qr-login-token';
